import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {Image} from "../../model/Image";
import {HttpClient} from "@angular/common/http";
import {Metadata} from "../../model/Metadata";
import {environment} from "../../../environments/environment";
import { Package } from "../../model/Package";

@Injectable({
  providedIn: 'root'
})
export class InprocessService {

  urlInProcess: string = '/inprocess';

  constructor(private http: HttpClient) {}

  public getInProcessPackages(): Observable<any> {
    return this.http.get<Package>(`${environment.packagesManagerBackendUrl}` + this.urlInProcess);
  }

  public getInProcessPackagesPagination(page): Observable<any> {
    return this.http.get<Package>(`${environment.packagesManagerBackendUrl}` + this.urlInProcess + '/page/' + page);
  }

  public deleteInProcessPackage(pkgId: number): Observable<any> {
    return this.http.delete(`${environment.packagesManagerBackendUrl}` + this.urlInProcess + '/delete/' + pkgId);
  }

}
